"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var constants_1 = require("../../../../constants");
var hooks_1 = require("../../../../hooks");
var utils_1 = require("../../../../utils/utils");
var Button_1 = __importDefault(require("../../../Button/Button"));
var DeleteComps_1 = require("../DeleteComps");
var DropDownMenu_1 = __importDefault(require("../DropDownMenu"));
var SkutecnostWrap = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  color: #000000;\n  font-size: 15px;\n"], ["\n  ",
    "\n  color: #000000;\n  font-size: 15px;\n"])), function (_a) {
    var $isModal = _a.$isModal;
    return $isModal && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-top: 0.5rem;\n      padding: 1rem;\n      background: #e5ebf0;\n\n      p:first-of-type {\n        margin-top: 0;\n      }\n\n      p {\n        margin-bottom: 0;\n      }\n    "], ["\n      margin-top: 0.5rem;\n      padding: 1rem;\n      background: #e5ebf0;\n\n      p:first-of-type {\n        margin-top: 0;\n      }\n\n      p {\n        margin-bottom: 0;\n      }\n    "])));
});
var PoznamkaDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  word-wrap: break-word;\n"], ["\n  word-wrap: break-word;\n"])));
var SDate = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-weight: bold;\n  margin-bottom: 5px !important;\n"], ["\n  font-weight: bold;\n  margin-bottom: 5px !important;\n"])));
var DetailSkutecnosti = function (_a) {
    var skutecnost = _a.skutecnost, isModal = _a.isModal, handleEdit = _a.handleEdit, handleSmazat = _a.handleSmazat, deleteOtazka = _a.deleteOtazka;
    var showDeleteDialog = hooks_1.useBoolean(false);
    var ref = react_1.useRef(null);
    var deleteText = ramda_1.cond([
        [ramda_1.equals(constants_1.TypSkutecnosti.vytka), ramda_1.always('Uložená výtka')],
        [ramda_1.equals(constants_1.TypSkutecnosti.spravniRizeni), ramda_1.always('Správní řízení')],
        [ramda_1.T, ramda_1.always('Jiná skutečnost')],
    ])(skutecnost.idTypSkutecnosti);
    var deleteTextEnding = ramda_1.cond([
        [ramda_1.equals(constants_1.TypSkutecnosti.vytka), ramda_1.always('byla úspěšně smazána.')],
        [ramda_1.equals(constants_1.TypSkutecnosti.spravniRizeni), ramda_1.always('bylo úspěšně smazáno.')],
        [ramda_1.T, ramda_1.always('byla úspěšně smazána.')],
    ])(skutecnost.idTypSkutecnosti);
    react_1.useEffect(function () {
        if (ref.current && showDeleteDialog.value) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [showDeleteDialog.value]);
    var getDeleteMessage = function () {
        return (react_1.default.createElement("div", null,
            deleteText,
            " ze dne ",
            utils_1.formatDate(skutecnost.datum),
            " ",
            deleteTextEnding));
    };
    return (react_1.default.createElement(SkutecnostWrap, { "$isModal": isModal, ref: ref },
        isModal && react_1.default.createElement(DropDownMenu_1.default, { handleEdit: handleEdit, handleDelete: showDeleteDialog.setTrue, id: skutecnost.id }),
        react_1.default.createElement(SDate, null, utils_1.formatDate(skutecnost.datum)),
        react_1.default.createElement(PoznamkaDiv, null, skutecnost.poznamka),
        !isModal && react_1.default.createElement("br", null),
        showDeleteDialog.value && (react_1.default.createElement(DeleteComps_1.DeleteDialog, { id: "deleteDialog" + skutecnost.id },
            react_1.default.createElement(DeleteComps_1.DeleteDialogText, null, deleteOtazka),
            react_1.default.createElement(DeleteComps_1.DeleteButtonsWrap, null,
                react_1.default.createElement(Button_1.default, { type: "button", primary: false, onClick: showDeleteDialog.setFalse, name: "Zachovat" }, "NE, ZACHOVAT"),
                react_1.default.createElement(Button_1.default, { type: "button", primary: true, onClick: function () { return handleSmazat(skutecnost.id, getDeleteMessage()); }, name: "Smazat" }, "ANO, SMAZAT"))))));
};
DetailSkutecnosti.defaultProps = {
    isModal: false,
};
exports.default = DetailSkutecnosti;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
